export const SDK_VERSION = '8.1.0';
